var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13380",
    "data-name": "Path 13380",
    d: "M20.667,4.231H18V3H16.667V4.231H11.333V3H10V4.231H7.333A1.289,1.289,0,0,0,6,5.462V17.769A1.289,1.289,0,0,0,7.333,19H20.667A1.289,1.289,0,0,0,22,17.769V5.462A1.289,1.289,0,0,0,20.667,4.231Zm0,13.538H7.333V9.154H20.667Zm0-9.846H7.333V5.462H10V6.692h1.333V5.462h5.333V6.692H18V5.462h2.667Z",
    transform: "translate(-6 -3)",
    fill: "#868a97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d4b2afce4ccf71d447edd57a1bf5e312.svg";
export { ForwardRef as ReactComponent };